module.exports = __webpack_public_path__ + "img/calendar.6e6eb79c.svg";